/*//      <editor-fold desc="jquery MatchHeight">

 /!**
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License: MIT
 *!/

 ;( function(factory){ // eslint-disable-line no-extra-semi
 'use strict';
 if (typeof define === 'function' && define.amd) {
 // AMD
 define([ 'jquery' ], factory);
 } else if (typeof module !== 'undefined' && module.exports) {
 // CommonJS
 module.exports = factory(require('jquery'));
 } else {
 // Global
 factory(jQuery);
 }
 } )(function($){
 /!*
 *  internal
 *!/

 var _previousResizeWidth = -1,
 _updateTimeout       = -1;

 /!*
 *  _parse
 *  value parse utility function
 *!/

 var _parse = function(value){
 // parse value and convert NaN to 0
 return parseFloat(value) || 0;
 };

 /!*
 *  _rows
 *  utility function returns array of jQuery selections representing each row
 *  (as displayed after float wrapping applied by browser)
 *!/

 var _rows = function(elements){
 var tolerance = 1,
 $elements = $(elements),
 lastTop   = null,
 rows      = [];

 // group elements by their top position
 $elements.each(function(){
 var $that   = $(this),
 top     = $that.offset().top - _parse($that.css('margin-top')),
 lastRow = rows.length > 0 ? rows[ rows.length - 1 ] : null;

 if (lastRow === null) {
 // first item on the row, so just push it
 rows.push($that);
 } else {
 // if the row top is the same, add to the row group
 if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {f
 rows[ rows.length - 1 ] = lastRow.add($that);
 } else {
 // otherwise start a new row group
 rows.push($that);
 }
 }

 // keep track of the last row top
 lastTop = top;
 });

 return rows;
 };

 /!*
 *  _parseOptions
 *  handle plugin options
 *!/

 var _parseOptions = function(options){
 var opts = {
 byRow: true,
 property: 'height',
 target: null,
 remove: false
 };

 if (typeof options === 'object') {
 return $.extend(opts, options);
 }

 if (typeof options === 'boolean') {
 opts.byRow = options;
 } else if (options === 'remove') {
 opts.remove = true;
 }

 return opts;
 };

 /!*
 *  matchHeight
 *  plugin definition
 *!/

 var matchHeight = $.fn.matchHeight = function(options){
 var opts = _parseOptions(options);

 // handle remove
 if (opts.remove) {
 var that = this;

 // remove fixed height from all selected elements
 this.css(opts.property, '');

 // remove selected elements from all groups
 $.each(matchHeight._groups, function(key, group){
 group.elements = group.elements.not(that);
 });

 // TODO: cleanup empty groups

 return this;
 }

 if (this.length <= 1 && !opts.target) {
 return this;
 }

 // keep track of this group so we can re-apply later on load and resize events
 matchHeight._groups.push({
 elements: this,
 options: opts
 });

 // match each element's height to the tallest element in the selection
 matchHeight._apply(this, opts);

 return this;
 };

 /!*
 *  plugin global options
 *!/

 matchHeight.version         = '0.7.2';
 matchHeight._groups         = [];
 matchHeight._throttle       = 80;
 matchHeight._maintainScroll = false;
 matchHeight._beforeUpdate   = null;
 matchHeight._afterUpdate    = null;
 matchHeight._rows           = _rows;
 matchHeight._parse          = _parse;
 matchHeight._parseOptions   = _parseOptions;

 /!*
 *  matchHeight._apply
 *  apply matchHeight to given elements
 *!/

 matchHeight._apply = function(elements, options){
 var opts      = _parseOptions(options),
 $elements = $(elements),
 rows      = [ $elements ];

 // take note of scroll position
 var scrollTop  = $(window)
 .scrollTop(),
 htmlHeight = $('html')
 .outerHeight(true);

 // get hidden parents
 var $hiddenParents = $elements.parents()
 .filter(':hidden');

 // cache the original inline style
 $hiddenParents.each(function(){
 var $that = $(this);
 $that.data('style-cache', $that.attr('style'));
 });

 // temporarily must force hidden parents visible
 $hiddenParents.css('display', 'block');

 // get rows if using byRow, otherwise assume one row
 if (opts.byRow && !opts.target) {

 // must first force an arbitrary equal height so floating elements break evenly
 $elements.each(function(){
 var $that   = $(this),
 display = $that.css('display');

 // temporarily force a usable display value
 if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
 display = 'block';
 }

 // cache the original inline style
 $that.data('style-cache', $that.attr('style'));

 $that.css({
 'display': display,
 'padding-top': '0',
 'padding-bottom': '0',
 'margin-top': '0',
 'margin-bottom': '0',
 'border-top-width': '0',
 'border-bottom-width': '0',
 'height': '100px',
 'overflow': 'hidden'
 });
 });

 // get the array of rows (based on element top position)
 rows = _rows($elements);

 // revert original inline styles
 $elements.each(function(){
 var $that = $(this);
 $that.attr('style', $that.data('style-cache') || '');
 });
 }

 $.each(rows, function(key, row){
 var $row         = $(row),
 targetHeight = 0;

 if (!opts.target) {
 // skip apply to rows with only one item
 if (opts.byRow && $row.length <= 1) {
 $row.css(opts.property, '');
 return;
 }

 // iterate the row and find the max height
 $row.each(function(){
 var $that   = $(this),
 style   = $that.attr('style'),
 display = $that.css('display');

 // temporarily force a usable display value
 if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
 display = 'block';
 }

 // ensure we get the correct actual height (and not a previously set height value)
 var css              = { 'display': display };
 css[ opts.property ] = '';
 $that.css(css);

 // find the max height (including padding, but not margin)
 if ($that.outerHeight(false) > targetHeight) {
 targetHeight = $that.outerHeight(false);
 }

 // revert styles
 if (style) {
 $that.attr('style', style);
 } else {
 $that.css('display', '');
 }
 });
 } else {
 // if target set, use the height of the target element
 targetHeight = opts.target.outerHeight(false);
 }

 // iterate the row and apply the height to all elements
 $row.each(function(){
 var $that           = $(this),
 verticalPadding = 0;

 // don't apply to a target
 if (opts.target && $that.is(opts.target)) {
 return;
 }

 // handle padding and border correctly (required when not using border-box)
 if ($that.css('box-sizing') !== 'border-box') {
 verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
 verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
 }

 // set the height (accounting for padding and border)
 $that.css(opts.property, ( targetHeight - verticalPadding ) + 'px');
 });
 });

 // revert hidden parents
 $hiddenParents.each(function(){
 var $that = $(this);
 $that.attr('style', $that.data('style-cache') || null);
 });

 // restore scroll position if enabled
 if (matchHeight._maintainScroll) {
 $(window)
 .scrollTop(( scrollTop / htmlHeight ) * $('html')
 .outerHeight(true));
 }

 return this;
 };

 /!*
 *  matchHeight._applyDataApi
 *  applies matchHeight to all elements with a data-match-height attribute
 *!/

 matchHeight._applyDataApi = function(){
 var groups = {};

 // generate groups by their groupId set by elements using data-match-height
 $('[data-match-height], [data-mh]')
 .each(function(){
 var $this   = $(this),
 groupId = $this.attr('data-mh') || $this.attr('data-match-height');

 if (groupId in groups) {
 groups[ groupId ] = groups[ groupId ].add($this);
 } else {
 groups[ groupId ] = $this;
 }
 });

 // apply matchHeight to each group
 $.each(groups, function(){
 this.matchHeight(true);
 });
 };

 /!*
 *  matchHeight._update
 *  updates matchHeight on all current groups with their correct options
 *!/

 var _update = function(event){
 if (matchHeight._beforeUpdate) {
 matchHeight._beforeUpdate(event, matchHeight._groups);
 }

 $.each(matchHeight._groups, function(){
 matchHeight._apply(this.elements, this.options);
 });

 if (matchHeight._afterUpdate) {
 matchHeight._afterUpdate(event, matchHeight._groups);
 }
 };

 matchHeight._update = function(throttle, event){
 // prevent update if fired from a resize event
 // where the viewport width hasn't actually changed
 // fixes an event looping bug in IE8
 if (event && event.type === 'resize') {
 var windowWidth = $(window)
 .width();
 if (windowWidth === _previousResizeWidth) {
 return;
 }
 _previousResizeWidth = windowWidth;
 }

 // throttle updates
 if (!throttle) {
 _update(event);
 } else if (_updateTimeout === -1) {
 _updateTimeout = setTimeout(function(){
 _update(event);
 _updateTimeout = -1;
 }, matchHeight._throttle);
 }
 };

 /!*
 *  bind events
 *!/

 // apply on DOM ready event
 $(matchHeight._applyDataApi);

 // use on or bind where supported
 var on = $.fn.on ? 'on' : 'bind';

 // update heights on load and resize events
 $(window)[ on ]('load', function(event){
 matchHeight._update(false, event);
 });

 // throttled update heights on resize events
 $(window)[ on ]('resize orientationchange', function(event){
 matchHeight._update(true, event);
 });

 });

 //                          </editor-fold>*/

// $.noConflict();
function gramsToPounds(grams) {
    let parsedGrams = parseInt((grams), 10);
    return parsedGrams * 0.00220462;
}

function estimateShippingCost(pounds) {
    if (pounds < 100) {
        return 0;
    } else if (pounds <= 725) {
        return 250;
    } else if (pounds <= 1100) {
        return 300;
    } else if (pounds <= 1495) {
        return 400;
    } else if (pounds <= 1899) {
        return 475;
    } else if (pounds > 1899) {
        return 550;
    } else {
        return 'Error Calculating Shipping Cost';
    }
}

/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
//off
!function (e, t) {
    'function' == typeof define && define.amd ?
        define('ev-emitter/ev-emitter', t) :
        'object' == typeof module && module.exports ?
            module.exports = t() :
            e.EvEmitter = t();
}('undefined' != typeof window ? window : this, function () {
    function e() {
    }

    var t = e.prototype;
    return t.on = function (e, t) {
        if (e && t) {
            var i = this._events = this._events || {}, n = i[ e ] = i[ e ] || [];
            return n.indexOf(t) == -1 && n.push(t), this;
        }
    }, t.once = function (e, t) {
        if (e && t) {
            this.on(e, t);
            var i = this._onceEvents = this._onceEvents || {}, n = i[ e ] = i[ e ] || {};
            return n[ t ] = !0, this;
        }
    }, t.off = function (e, t) {
        var i = this._events && this._events[ e ];
        if (i && i.length) {
            var n = i.indexOf(t);
            return n != -1 && i.splice(n, 1), this;
        }
    }, t.emitEvent = function (e, t) {
        var i = this._events && this._events[ e ];
        if (i && i.length) {
            i = i.slice(0), t = t || [];
            for (var n = this._onceEvents && this._onceEvents[ e ], o = 0; o <
            i.length; o++) {
                var r = i[ o ], s = n && n[ r ];
                s && (this.off(e, r), delete n[ r ]), r.apply(this, t);
            }
            return this;
        }
    }, t.allOff = function () {
        delete this._events, delete this._onceEvents;
    }, e;
}), function (e, t) {
    'use strict';
    'function' == typeof define && define.amd ?
        define(['ev-emitter/ev-emitter'], function (i) {
            return t(e, i);
        }) :
        'object' == typeof module && module.exports ?
            module.exports = t(e, require('ev-emitter')) :
            e.imagesLoaded = t(e, e.EvEmitter);
}('undefined' != typeof window ? window : this, function (e, t) {
    function i(e, t) {
        for (var i in t) {
            e[ i ] = t[ i ];
        }
        return e;
    }

    function n(e) {
        if (Array.isArray(e)) {
            return e;
        }
        var t = 'object' == typeof e && 'number' == typeof e.length;
        return t ? d.call(e) : [e];
    }

    function o(e, t, r) {
        if (!(this instanceof o)) {
            return new o(e, t, r);
        }
        var s = e;
        return 'string' == typeof e && (s = document.querySelectorAll(e)), s ?
            (this.elements = n(s), this.options = i({},
                this.options), 'function' == typeof t ?
                r = t :
                i(this.options, t), r &&
            this.on('always', r), this.getImages(), h &&
            (this.jqDeferred = new h.Deferred), void setTimeout(
                this.check.bind(this))) :
            void a.error('Bad element for imagesLoaded ' + (s || e));
    }

    function r(e) {
        this.img = e;
    }

    function s(e, t) {
        this.url = e, this.element = t, this.img = new Image;
    }

    var h = e.jQuery, a = e.console, d = Array.prototype.slice;
    o.prototype = Object.create(
        t.prototype), o.prototype.options = {}, o.prototype.getImages = function () {
        this.images = [], this.elements.forEach(this.addElementImages, this);
    }, o.prototype.addElementImages = function (e) {
        'IMG' == e.nodeName && this.addImage(e), this.options.background === !0 &&
        this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && u[ t ]) {
            for (var i = e.querySelectorAll('img'), n = 0; n < i.length; n++) {
                var o = i[ n ];
                this.addImage(o);
            }
            if ('string' == typeof this.options.background) {
                var r = e.querySelectorAll(this.options.background);
                for (n = 0; n < r.length; n++) {
                    var s = r[ n ];
                    this.addElementBackgroundImages(s);
                }
            }
        }
    };
    var u = {
        1: !0,
        9: !0,
        11: !0,
    };
    return o.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t) {
            for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(
                t.backgroundImage); null !== n;) {
                var o = n && n[ 2 ];
                o && this.addBackground(o, e), n = i.exec(t.backgroundImage);
            }
        }
    }, o.prototype.addImage = function (e) {
        var t = new r(e);
        this.images.push(t);
    }, o.prototype.addBackground = function (e, t) {
        var i = new s(e, t);
        this.images.push(i);
    }, o.prototype.check = function () {
        function e(e, i, n) {
            setTimeout(function () {
                t.progress(e, i, n);
            });
        }

        var t = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ?
            void this.images.forEach(function (t) {
                t.once('progress', e), t.check();
            }) :
            void this.complete();
    }, o.prototype.progress = function (e, t, i) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken ||
            !e.isLoaded, this.emitEvent(
            'progress', [
                this,
                e,
                t]), this.jqDeferred && this.jqDeferred.notify &&
        this.jqDeferred.notify(this,
            e), this.progressedCount ==
        this.images.length &&
        this.complete(), this.options.debug &&
        a && a.log(
            'progress: ' + i, e, t);
    }, o.prototype.complete = function () {
        var e = this.hasAnyBroken ? 'fail' : 'done';
        if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent(
            'always', [this]), this.jqDeferred) {
            var t = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[ t ](this);
        }
    }, r.prototype = Object.create(t.prototype), r.prototype.check = function () {
        var e = this.getIsImageComplete();
        return e ?
            void this.confirm(0 !== this.img.naturalWidth, 'naturalWidth') :
            (this.proxyImage = new Image, this.proxyImage.addEventListener('load',
                this), this.proxyImage.addEventListener('error',
                this), this.img.addEventListener('load',
                this), this.img.addEventListener('error',
                this), void (this.proxyImage.src = this.img.src));
    }, r.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
    }, r.prototype.confirm = function (e, t) {
        this.isLoaded = e, this.emitEvent('progress', [
            this,
            this.img,
            t]);
    }, r.prototype.handleEvent = function (e) {
        var t = 'on' + e.type;
        this[ t ] && this[ t ](e);
    }, r.prototype.onload = function () {
        this.confirm(!0, 'onload'), this.unbindEvents();
    }, r.prototype.onerror = function () {
        this.confirm(!1, 'onerror'), this.unbindEvents();
    }, r.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener('load',
            this), this.proxyImage.removeEventListener('error',
            this), this.img.removeEventListener('load',
            this), this.img.removeEventListener('error', this);
    }, s.prototype = Object.create(r.prototype), s.prototype.check = function () {
        this.img.addEventListener('load', this), this.img.addEventListener('error',
            this), this.img.src = this.url;
        var e = this.getIsImageComplete();
        e && (this.confirm(0 !== this.img.naturalWidth,
            'naturalWidth'), this.unbindEvents());
    }, s.prototype.unbindEvents = function () {
        this.img.removeEventListener('load', this), this.img.removeEventListener(
            'error', this);
    }, s.prototype.confirm = function (e, t) {
        this.isLoaded = e, this.emitEvent('progress', [
            this,
            this.element,
            t]);
    }, o.makeJQueryPlugin = function (t) {
        t = t || e.jQuery, t && (h = t, h.fn.imagesLoaded = function (e, t) {
            var i = new o(this, e, t);
            return i.jqDeferred.promise(h(this));
        });
    }, o.makeJQueryPlugin(), o;
});
//on
jQuery(document)
    .ready(function ($) {
        function OpenInNewTab(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }

        function xsts(xsistsSelector) {
            var element = $(xsistsSelector);
            if (element.length > 0 & typeof (element) != 'undefined' && element != null) {
                // console.log('xistS: ' + xsistsSelector);
                return true;
            } else {
                // console.log(xsistsSelector + ' does not exist!');
                return false;
            }
        };

        function sameHeight(ell) {
            var hh = 0;
            $(ell)
                .each(function () {
                    var $this = $(this);
                    var h = $this.innerHeight();
                    if (h > hh) {
                        hh = h;
                    }
                });
            $(ell)
                .innerHeight(hh);
        };$('[data-link-tab]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('link-tab');
                OpenInNewTab(url);
            });
        $('[data-tab]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('tab');
                OpenInNewTab(url);
            });
        $('[data-tab-link]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('tab-link');
                OpenInNewTab(url);
            });
        $('[data-link-ref]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('link-ref');
                OpenInNewTab(url);
            });
        $('[data-link-href]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('link-href');
                OpenInNewTab(url);
            });
        $('[data-href]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('href');
                OpenInNewTab(url);
            });
        $('[data-link]')
            .on('click', function (e) {
                e.preventDefault();
                var url = $(this)
                    .data('link');
                OpenInNewTab(url);
            });

        function OpenInNewTab(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }

        // $('.mw-options-container').on('click', function(){
        //     swatchOptionCheck();
        // })
        // function swatchOptionCheck() {
        //
        //     $propSize =  $('[name=properties[Size]]');
        //
        //     if ( true ) {
        //         console.log('Property Size: ' + $propSize);
        // }
        if ($(window)
            .width() > 750) {
            try {
                sameHeight(
                    $('#shopify-section-1574789853033 .feature-row__image-wrapper'));
            } catch (e) {
                console.log(`${e}`);
            }
            try {
                sameHeight($('#shopify-section-1574789853033 .grid__item'));
            } catch (e) {
                console.log(`${e}`);
            }
            try {
                sameHeight($('#shopify-section-1574789853033 .grid .grid__item'));
            } catch (e) {
                console.log(`${e}`);
            }
            try {
                sameHeight($('#shopify-section-featured-collections h4'));
            } catch (e) {
                console.log(`${e}`);
            }
            try {
                sameHeight($('.techFeatures'));
            } catch (e) {
                console.log(`${e}`);
            }
            try {
                sameHeight($('.Accessories'));
            } catch (e) {
                console.log(`${e}`);
            }
        } else {

            /* $('.m-nav[data-meteor-level="1"]').find('> a').each(() => {
             var $newHREF = $(this);
             console.log($newHREF);


             $newHREF.on('click mousedown touch touchstart', function( e ) {
             e.preventDefault();
             console.log($newHREF);
             var $vendorURL = $newHREF.find('a').data('meteor-url');
             console.log($vendorURL);
             });
             });*/
        }
        // if (xsts('.grid__item--collection-template:contains("Franklin 25")')) {
        //
        //     if ($('.grid__item--collection-template:contains("Franklin 25")').length > 0) {
        //         $("#somediv").addClass("thisClass");
        //     }
        //
        // }
        if (xsts('.toast')) {
            $('.toast')
                .each(function () {
                    var $toast = $(this);
                    var toastTime = new TimelineMax({
                        paused: true,
                        delay: 2,
                        onReverseComplete: reverseCompFunction,
                    }).from($(this)
                          .find('*'), 2, {
                          opacity: 0,
                          y: '1rem',
                          height: '0rem',
                          ease: Expo.easeInOut,
                          stagger: .06,
                          duration: 1,
                          marginTop: 0,
                          marginBottom: 0,
                      }, 0)
                      .from($(this), {
                          marginTop: '0rem',
                          paddingTop: '0rem',
                          marginBottom: '0rem',
                          paddingBottom: '0rem',
                          duration: 1,
                          opacity: 0,
                      }, 0)
                      .to($(this), 2, {
                          opacity: 1,
                          ease: Expo.easeInOut,
                          stagger: .06,
                          duration: 1,
                      }, 1)
                      .play();
                    toastTime.play();
                    $toast.find('.close')
                          .on('click mousedown', function (e) {
                              e.preventDefault();
                              toastTime.reverse(1.6);
                              /*gsap.to($toast, {
                               opaicity: 0, // scale: .97,
                               height: '0rem',
                               duration: 1,

                               }, 0)
                               .to($toast.find('*'), {opacity: 0, stagger: .06, ease:Expo.easeInOut, duration:1});*/
                              // window.$toastTimeline.reverse(2);
                          });

                    function reverseCompFunction() {
                        gsap.to($(this), {
                            height: '0rem',
                            duration: 1,
                            ease: Expo.easeInOut,
                        });
                        $(this)
                            .remove();
                    }
                });
            /* new TimelineMax({paused: true}).staggerTo($('.toast'), 4, {
             opacity: 1,
             ease: Expo.easeInOut
             }, 0.4, '+=3').play();*/
        }
        /* try {
         sameHeight($('.h4.grid-view-item__title'));
         } catch (e) {
         console.log('Resize Error');
         console.log(`${ e }`);
         }*/
        // console.log('Loaded');
        /*
         // Escape all RegEx reserved characters from string
         function escRegExp( str ) {
         return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
         }

         // Return matched elements based on regex contents
         function highlight( regex, element, child ) {
         // Create a regex based on the bot match string
         var regex = new RegExp(escRegExp(regex), 'gim');
         // Generate results based on regex matches within match_parent
         var results = [];
         // Check for element
         if ($(element).length) {
         // Match regex on parent element
         var match = $(element).text().match(regex);
         if (match != null) {
         // Push our matches onto results
         $(element).find(child).each(function( index, value ) {
         // Push child onto to results array if it contains our regex
         if ($(this).text().match(regex)) {
         results.push($(this));
         }
         });
         }
         }
         return results;
         }

         // // Get results example usage
         // var results = highlight('has', '#anothercontainer', 'div, li');
         // // Make them sexy and pink
         // $.each(results, function() {
         //     $(this).css({color: 'pink'});
         // });

         var $selectedOption = $('.mw-option-swatch').first().find('input[name^="prop"]').val();
         function runSelectFilters() {


         $('.swatch-value-container').each(function() {


         // optionTitle
         $elem = $(this);
         $optionTitle = $elem.find('.swatch-title').text();
         var textVal = $(this).text();

         if (textVal.includes($selectedOption)) {
         console.log("It contains text");
         $elem.show();
         } else {
         console.log("Does not contain");
         $elem.hide();
         }

         });
         }
         $('.swatch-value-container').each(function() {
         $(this).on('click', () => {

         $selectedOption = $('.mw-option-swatch').first().find('input[name^="prop"]').val();


         runSelectFilters();
         });
         });

         // only show if option title is in first swatch selected title*/
        if (xsts('.navDD')) {
            // console.log(`${ '.navDD exists' }`);
            $('.navDD')
                .each((i, elem) => {
                    var $elem = $(elem);
                    var $elemToggle = $(elem)
                        .find('> a');
                    var $elemToggleContent = $(elem)
                        .find('.locations');
                    // var $fblogo  = $(elem)
                    //     .find('img.brandLogo');
                    // console.log($fbinfo);
                    var tl = new TimelineMax({
                        paused: true,
                        reversed: true,
                    });
                    tl.set($elemToggleContent, { pointerEvents: 'none !important' }, 0.0)
                      .set($elemToggleContent, { pointerEvents: 'all' }, 0.04)
                      .fromTo($elemToggleContent, 0.86, {
                          opacity: 0,
                          y: '-5rem',
                          zIndex: -3,
                          paddingTop: '0rem',
                      }, {
                          opacity: 1,
                          y: '0rem',
                          paddingTop: '1rem',
                          ease: Expo.easeOut,
                          zIndex: 20,
                      }, 0)
                      .staggerFromTo($elemToggleContent.find('*'), .8, {
                          opacity: 0,
                          x: '-1rem',
                      }, {
                          opacity: 1,
                          x: '0rem',
                          ease: Expo.easeOut,
                      }, .01, 0);
                    // .fromTo($elemToggle, 1, {
                    //     height: '0rem',
                    //     margin: '0rem',
                    //     paddingTop: '0rem',
                    //     paddingBottom: '0rem',
                    //     ease: Expo.easeOut
                    // }, 0);
                    // var $maptl = new TimelineMax({ paused: true })
                    //     .to($(elem)
                    //         .find('.newBackImg, .overlay'), 1, {
                    //         opacity: .23,
                    //         ease: Expo.easeInOut
                    //     }, 0);
                    $elemToggle.on('mouseenter', inM);
                    // $elemToggle.on('mouseleave', outM);
                    $elem.on('mouseleave', outM);

                    // $elem.on('mouseenter', inM);
                    function inM() {
                        gsap.set($elemToggleContent, {
                            pointerEvents: 'all',
                        });
                        tl.play();
                    }

                    function outM() {
                        gsap.set($elemToggleContent, {
                            pointerEvents: 'none',
                        });
                        tl.reverse();
                    }
                });
        }
        if (xsts('.countdown')) {
            // Set the date we're counting down to
            var countDownDate = new Date('April , 2021 15:37:25').getTime();
            // Update the count down every 1 second
            var x = setInterval(function () {
                // Get todays date and time
                var now = new Date().getTime();
                // Find the distance between now an the count down date
                var distance = countDownDate - now;
                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                // Display the result in an element with id="demo"
                document.getElementById('countdown').innerHTML = days + 'd ' + hours +
                    'h ' + minutes + 'm ' +
                    seconds + 's ';
                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    document.getElementById('countdown').innerHTML = 'EXPIRED';
                }
            }, 1000);
        }
        if (xsts('.reroute')) {
            // gsap.set($('.secureLiberties'), {letterSpacing: '3px'});
            setTimeout(function () {
                var reRoute = new TimelineMax().staggerTo('.reRoute, .reRoute svg', 1, {
                                                   opacity: 1,
                                                   ease: Expo.easeInOut,
                                               }, .2, 0)
                                               .staggerFromTo($('.reRoute')
                                                   .find('*'), 3, {
                                                   opacity: 0,
                                                   y: '-3rem',
                                                   ease: Expo.easeOut,
                                               }, {
                                                   opacity: 1,
                                                   y: '0rem',
                                                   ease: Expo.easeOut,
                                               }, .1, .8);
            }, 1000);
        }
        // $(window)
        //     .on('resize', function(){
        //         var obj    = $('.if');
        //         obj.height = obj.contentWindow.document.body.scrollHeight + 'px';
        //     });
        /* try {

         // resize('.FMFapplication');
         // console.log(`${ 'Iframe Resized' }`);
         $('#FMFapplication')
         .on('mouseenter', function(e){
         resize('#FMFapplication');
         });

         } catch (e) {

         console.log(`${ e }`);

         }*/
        /**
         * Called to resize a given iframe.
         *
         * @param frame The iframe to resize.
         */
        // $('iframe').on(resizeEvent, function(){
        //     console.log(`${ this }`);
        // })
        // function resize(fr){
        //     var resizeInterval = setInterval(function(){
        //         var frame = $(fr);
        //         var h     = $(fr)
        //             .outerHeight();
        //         console.log(`${ h }`);
        //
        //         $(fr)
        //             .parent()
        //             .height(h + 'px');
        //     }, 4500);
        //
        // }
        $('.site-header__icons-wrapper')
            .on('mouseenter focus click focusin', function () {
                $(this)
                    .find('form')
                    .addClass('search--focus');
            });
        $('.site-header__icons-wrapper')
            .on('blur', function () {
                $(this)
                    .find('form')
                    .removeClass('search--focus');
            });
        var $TSVSlides = new TimelineMax();
        if (xsts('#TSVSlides')) {
            /*$TSVSlides = $('#TSVSlides').carousel({

             interval: false, // keyboard: 'false',
             touch: false,
             pause: false,
             wrap: false

             });*/
            $('#TSVSlides')
                .on('slide.bs.carousel', function () {
                    gsap.set($('.carousel-item')
                        .not('.active')
                        .find('*'), { opacity: 0 });
                    $TSVTimeline = new TimelineMax().to($('.carousel-item.active')
                            .find('*'),
                        {
                            opacity: .01,
                            stagger: {
                                amount: 1,
                                each: .1,
                                ease: Expo.eaesIn,
                            },
                        });
                    // $gSlide = $('#TSVSlides').find('.carousel-item.active');
                    // $gElems = $gSlide.find('.descript *, .contentImages img');
                    // $TSVTimeline = gsap.to($('#TSVSlides .active').find('p, h1, h2, h3,h4, h5, h6, span, img, button'), {
                    //     opacity: 1,
                    //     ease: Expo.easeIn,
                    //     stagger: 0.06,
                    //     ease: Expo.easeOut
                    // });
                });
            $('#TSVSlides')
                .on('slid.bs.carousel', function () {
                    // $gSlide = $('#TSVSlides').find('.carousel-item.active');
                    // $gElems = $gSlide.find('.descript *, .contentImages img');
                    $TSVTimeline.kill();
                    gsap.set($('.carousel-item.active')
                        .find('*'), { opacity: 0 });
                    $TSVTimeline = new TimelineMax().fromTo(
                                                        $('.carousel-item.active')
                                                            .find('*'), {
                                                            opacity: 0,
                                                        }, {
                                                            opacity: 1,
                                                            stagger: {
                                                                amount: .6,
                                                                each: 1,
                                                                ease: Expo.easeOut,
                                                            },
                                                        })
                                                    .play();
                    /*$gtl = new gsap.to($gElems, {
                     opacity: 1,
                     x: '0rem',
                     stagger: .4,
                     ease: Expo.easeOut,
                     duration: 3
                     });
                     console.log();*/
                    // tl.to("#id", {x: 100, duration: 1});
                    // tl.to("#id", {y: 50, duration: 1});
                    // tl.to("#id", {opacity: 0, duration: 1});
                    //
                    // // then we can control the whole thing easily...
                    // tl.pause();
                    // tl.resume();
                    // tl.seek(1.5);
                    // tl.reverse();
                    // window.$tl.kill();
                    // do something…
                    // gsap.to($(this).find('*'), {
                    //     opacity: 1,
                    //     x: '0rem',
                    //     ease: Expo.easeOut
                    // });
                    // new TimelineMax().staggerFromTo($)
                });
            // $('#TSVSlides').swipe({
            //     swipe: function( event, direction, distance, duration, fingerCount, fingerData ) {
            //         var $this = this;
            //         if (direction == 'left') {
            //             $($this).carousel('next');
            //             // gsap.to('.descript *', {
            //             //     opacity: 0,
            //             //     x: '-3rem',
            //             //     stagger: 0.01,
            //             //     ease: Expo.easeIn,
            //             //     onComplete: () => {
            //             //         nextSlide();
            //             //     }
            //             // });
            //             // function nextSlide() {
            //             //     console.log('Triggering');
            //             //     $($this).carousel('next');
            //             // }
            //         }
            //         if (direction == 'right') {
            //             // gsap.to($('.descript'), {
            //             //     opacity: 0,
            //             //     ease: Expo.easeOut,
            //             //     x: '3rem',
            //             //     stagger: 0.01,
            //             //     onComplete: () => {
            //             //         function prevSlide() {
            //             //             console.log('Triggering');
            //             //             $($this).carousel('prev');
            //             //         }
            //             //
            //             //         prevSlide();
            //             //
            //             //     }
            //             //
            //             // });
            //             $($this).carousel('prev');
            //
            //         }
            //     },
            //     allowPageScroll: 'vertical'
            // });
            var $TABTimeline = new TimelineMax();
            /*$('ul.tabs').each(function() {
             var active, content, links = $(this).find('a');
             active = links.first().addClass('active');
             content = $(active.attr('href'));
             links.not(':first').each(function() {
             $($(this).attr('href')).hide();
             });
             $(this).find('a').click(function( e ) {
             active.removeClass('active');
             content.hide();
             active = $(this);
             content = $($(this).attr('href'));
             active.addClass('active');
             content.show();
             return false;
             });
             });*/
            $('[data-title-trigger]')
                .each(function () {
                    var $tab = $(this);
                    var $slideTitleTrigger = $tab.data('title-trigger');
                    console.log($slideTitleTrigger);
                    var $tabItem = $tab.data('tab-item');
                    $tab.on('click', function (e) {
                        e.preventDefault();
                        console.log($slideTitleTrigger);
                        var $slideNum = $('#TSVSlides')
                            .find('[data-title=\'' + $slideTitleTrigger + '\']')
                            .index();
                        console.log($slideNum);
                        $TSVSlides.carousel($slideNum);
                    });
                    console.log($tab.index());
                });
            /*$('.nav-tabs > li').each(function() {
             var $this = $(this);
             /!*var active, content, links = $(this).find('a');
             var active = links.first().addClass('active');
             content = $(active.attr('href'));
             links.not(':first').each(function() {
             $($(this).attr('href')).hide();
             });
             $(this).find('a').click(function( e ) {
             console.log(`${ content }`);
             active.removeClass('active');
             content.hide();
             active = $(this);
             content = $($(this).attr('href'));
             active.addClass('active');
             content.show();
             console.log(content);

             return false;
             $TABTimeline.kill();

             /!*$TABTimeline = new TimelineMax().staggerTo($(this).attr('href'), 3, {
             opacity: 0,
             onComplete: function() {

             }
             }, .2, 0);*!/
             });*!/
             /!*$(this).on('click', function( e ) {
             e.preventDefault();
             var $slideTitleTrigger = $(this).data('title-trigger');
             var $tabItem = $this.data('tab-item');



             console.log($slideTitleTrigger);
             var $slideNum = $('#TSVSlides').find('[data-title="' + $slideTitleTrigger + ']"').index();
             console.log($slideNum);

             $TSVSlides.carousel($slideNum);
             var $this = this;


             // gsap.to($('.tab-pane.active').find('img, p, h1, h2, h3, h4, h5, h6, span, div'), {
             //     opacity: 0,
             //     y: '-2rem',
             //     ease: Expo.easeOut,
             //     stagger: {
             //         'amount': 0.2,
             //         'each': 1,
             //         ease: Expo.easeOut
             //     }
             // });
             });*!/
             });*/
            if (xsts('.reRoute2')) {
                // gsap.set($('.secureLiberties'), {letterSpacing: '3px'});
                var reRoute2 = new TimelineMax().staggerTo('.reRoute2', 1, {
                                                    opacity: 1,
                                                    ease: Expo.easeInOut,
                                                }, .2, 0)
                                                .staggerFromTo($('.reRoute2')
                                                    .find('*, .warningSVG, .warning'), 3, {
                                                    opacity: 0,
                                                    y: '-3rem',
                                                    ease: Expo.easeOut,
                                                }, {
                                                    opacity: 1,
                                                    y: '0rem',
                                                    ease: Expo.easeOut,
                                                }, .1, .8);
                var $rrButton = $('.reRoute2')
                    .find('button');
                var $rrInstructions = $('.reroute2')
                    .find('ul');
                $('.reRoute2')
                    .find('button')
                    .on('click', function () {
                        // gsap.set($rrInstructions, {display: 'inline-block'});
                        $('.rrInst')
                            .toggleClass('showInstructions');
                    });
            }
            if (xsts('.cInv')) {
                let $inventorySlicked = $('.cInv');
                $('.cInv')
                    .imagesLoaded()
                    .always(function (instance) {
                        // gsap.set($inventorySlicked, {
                        //     display: 'inline-flex',
                        //     opacity: 0,
                        //     height: 'auto'
                        // });
                        console.log('all images loaded');
                        $('.cInv')
                            .on('init', function (event, slick) {
                                console.log(`${'Slick Initialized'}`);
                                gsap.set($inventorySlicked, {
                                    opacity: 0,
                                    display: 'inline-block',
                                });
                                gsap.to($inventorySlicked, {
                                    opacity: 1,
                                    duration: 1,
                                    ease: Expo.easeInOut,
                                });
                                /* gsap.timeline({
                                 delay: 2,
                                 }).from($inventorySlicked, {

                                 height: 0,
                                 opacity: 0,
                                 duration: 1,
                                 }, 1)
                                 .to($inventorySlicked, {
                                 opacity: 1,
                                 duration: 1,
                                 ease: Expo.easeOut,
                                 duration: 1
                                 }, 2).play()*/
                                /*gsap.to($inventorySlicked, {
                                 opacity: 1,
                                 duration: 1
                                 });*/
                            });
                        $inventorySlicked.slick({
                            // centerMode: true,
                            infinite: true,
                            dots: false, // prevArrow: '<button class="slide-arrow prev-arrow">Previous</button>',
                            // nextArrow: '<button class="slide-arrow next-arrow">Next</button>',
                            speed: 300,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            autoplay: true,
                            autoplaySpeed: 14000, // centerMode: true,
                            // centerPadding: '60px',
                            arrows: true, // : 'progressive',
                            // lazyLoad: 'progressive' // fade: true,
                            /*responsive: [
                             {
                             breakpoint: 2100,
                             settings: {
                             slidesToShow: 5,
                             slidesToScroll: 1
                             }
                             }, {
                             breakpoint: 1008,
                             settings: {
                             slidesToShow: 2,
                             slidesToScroll: 1
                             }
                             }

                             ]*/
                        });
                        $('.nextInventory')
                            .on('click', function (e) {
                                $(this)
                                    .find('.overlay')
                                    .css('background', getRandomColor());
                                $inventorySlicked.slick('slickNext');
                            });
                        $('.prevInventory')
                            .on('click', function (e) {
                                $(this)
                                    .find('.overlay')
                                    .css('background', getRandomColor());
                                $inventorySlicked.slick('slickPrev');
                            });

                        function getRandomColor() {
                            var letters = '0123456789ABCDEF'.split('');
                            var color = '#';
                            for (var i = 0; i < 6; i++) {
                                color += letters[ Math.round(Math.random() * 15) ];
                            }
                            return color;
                        }

                        $(window)
                            .resize(function () {
                                $('.js-slider')
                                    .not('.slick-initialized')
                                    .slick('resize');
                            });
                        $(window)
                            .on('orientationchange', function () {
                                $('.js-slider')
                                    .not('.slick-initialized')
                                    .slick('resize');
                            });
                        ciHover();
                    })
                    .done(function (instance) {
                        console.log('all images successfully loaded');
                    })
                    .fail(function () {
                        console.log('all images loaded, at least one is broken');
                    })
                    .progress(function (instance, image) {
                        var result = image.isLoaded ? 'loaded' : 'broken';
                        console.log('image is ' + result + ' for ' + image.img.src);
                    });

                function ciHover() {
                    // console.log(`${ '.navDD exists' }`);
                    $('.cInv')
                        .each((i, elem) => {
                            var $elem = $(elem);
                            var $elemToggle = $(elem)
                                .find('> a');
                            var $arrows = $('.slick-arrow');
                            // var $fblogo  = $(elem)
                            //     .find('img.brandLogo');
                            // console.log($fbinfo);
                            var tl = gsap.timeline({
                                paused: true,
                                reversed: true,
                            });
                            tl.from('.slick-next', {
                                  rotation: 180,
                                  x: '-4rem',
                                  ease: Expo.easeOut,
                                  duration: 1.6,
                              }, 'arrowStart')
                              .from('.slick-prev', {
                                  rotation: -180,
                                  ease: Expo.easeOut,
                                  x: '3rem',
                                  duration: 1.6,
                              }, 'arrowStart+=.02')
                              .fromTo($elem.find('.slick-arrow'), {
                                  opacity: 0,
                              }, {
                                  opacity: 1,
                                  ease: Expo.easeOut,
                                  stagger: .06,
                                  duration: 1.6,
                              }, 'arrowStart')
                              .fromTo($elem.find('h1, h2, h3, h4, h5, h6, .slick-slide p a'), {
                                  opacity: 0,
                                  y: '-1rem',
                              }, {
                                  opacity: 1,
                                  ease: Expo.easeInOut,
                                  duration: 1,
                              }, '-=1');
                            // .fromTo($elemToggle, 1, {
                            //     height: '0rem',
                            //     margin: '0rem',
                            //     paddingTop: '0rem',
                            //     paddingBottom: '0rem',
                            //     ease: Expo.easeOut
                            // }, 0);
                            // var $maptl = new TimelineMax({ paused: true })
                            //     .to($(elem)
                            //         .find('.newBackImg, .overlay'), 1, {
                            //         opacity: .23,
                            //         ease: Expo.easeInOut
                            //     }, 0);
                            $elem.on('mouseenter', inM);
                            // $elemToggle.on('mouseleave', outM);
                            $elem.on('mouseleave', outM);

                            // $elem.on('mouseenter', inM);
                            function inM() {
                                tl.play();
                            }

                            function outM() {
                                tl.reverse(1.6);
                            }
                        });
                }
            }
        }
        if (xsts('.call')) {
            $('.call')
                .each(function () {
                    $(this)
                        .on('click', function () {
                            OpenInNewTab('tel:210-404-1365');
                        });
                });
        }
        if (xsts('.vendorImages')) {
            new Splide('.vendorImages', {
                perPage: 1,
                autoHeight: false,
                perMove: 1,
                interval: 6000,
                flickPower: 1,
                keyboard: true,
                autoWidth: true,
                drag: true,
                autoplay: true,
            }).mount();
        }
        if (xsts('.laborDayPromos')) {
            /* $('#laborDayPromos').slick({
             infinite: true,
             speed: 300,
             slidesToShow: 1,
             slidesToScroll: 1,
             arrows: true,
             // centerMode: true,
             dots: false
             });*/

            /*document.addEventListener('DOMContentLoaded', function() {
             new Splide('.splide', {
             rewind: true,
             pagination: false,

             });
             });*/

            new Splide('.laborDayPromos', {

                perPage: 1,
                type: 'loop',
                autoHeight: false,
                perMove: 1,
                interval: 5000,
                flickPower: 15,
                keyboard: true, // rewind: true,
                // autoWidth: false,
                drag: true,
                autoplay: true, // gap: '1rem'

            }).mount();
        }
        /*        if (xsts('.vendorContent')) {
         $('.vendorContent').swipe({
         swipeLeft: function( event, direction, distance, duration, fingerCount ) {
         $('.nav-tabs li.active').next('li').find('a').tab('show');
         },
         swipeRight: function( event, direction, distance, duration, fingerCount ) {
         $('.nav-tabs li.active').prev('li').find('a').tab('show');
         }
         });
         }*/
        if (xsts('.vendorProducts')) {
            // $('.vendorProducts > div').slick({
            //     infinite: true,
            //     speed: 300,
            //     slidesToShow: 5,
            //     slidesToScroll: 1,
            //     arrows: true,
            //     centerMode: true,
            //     dots: false
            // });
            new Splide('.splide', {
                type: 'loop',
                perPage: 5,
                autoHeight: true,
                perMove: 1,
                interval: 3000,
                flickPower: 15,
                keyboard: true,
                rewind: true,
                autoWidth: false,
                drag: true,
                autoplay: true,
                gap: '1rem',
            }).mount();
            // new Splide('.splide', {
            //     type: 'loop',
            //     perPage: 5,
            //     autoHeight: false,
            //     perMove: 1,
            //     interval: 3000,
            //     flickPower: 15,
            //     keyboard: true,
            //     rewind: true,
            //     autoWidth: true,
            //     drag: true,
            //     autoplay: true,
            //     gap: '1rem'
            //
            //
            // }).mount();
            /*$(this).on('click', function() {
             OpenInNewTab('tel:210-404-1365');
             });*/
        }

        function scrollTo() {
            if (xsts('[data-st]')) {
                $('[data-st]')
                    .each(function () {
                        $(this)
                            .on('click', function (e) {
                                e.preventDefault();
                                var $dataST = $(this)
                                    .data('st');
                                gsap.to(window, {
                                    duration: 1,
                                    ease: Expo.easeOut,
                                    scrollTo: {
                                        y: $dataST,
                                        offsetY: 50,
                                    },
                                });
                            });
                    });
            }
        }

        scrollTo();
        /*if (xsts('.lincoln-25-current-inventory')) {
         $('.lincoln-25-current-inventory').addClass('soldOut').append(`
         <div class="ribbons-wrapper"><div class="ribbon">
         <div class="wrap">
         <span
         class="ribbon6">Sold!</span>
         </div>
         </div></div>`);
         }*/
    });
// $('.slide, .fullSlide').slick({
//     // infinite: true,
//     // slidesToShow: 1,
//     slidesToScroll: 1,
//     dots: true,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     adaptiveHeight: true
// });
// Instantiate a slider
// var mySlider = $('.slides').find('.slide').slider();
// $('.bVideo').YTPlayer({
//     videoURL: 'NQ7DgWflnso',
//     fitToBackground: true,
//     containment: '#TSVSlides',
//     autoPlay: true,
//     mute: true,
//     startAt: 0,
//     opacity: 1
// });
/*$('#bgndVideo').BigVideo({
 // If you want to use a single mp4 source, set as true
 useFlashForFirefox: false, // If you are doing a playlist, the video won't play the first time
 // on a touchscreen unless the play event is attached to a user click
 forceAutoplay: true,
 controls: false,
 doLoop: true,
 container: $('#bgndVideo'),
 shrinkable: true
 });*/
// $('#video').YTPlayer({
//     fitToBackground: true,
//     videoId: 'NQ7DgWflnso'
/*   var player = new YTPlayer('player', {
 height: '390',
 width: '640',
 videoId: 'NQ7DgWflnso',
 events: {
 'onReady': onPlayerReady,
 'onStateChange': onPlayerStateChange
 }
 });*/
/*jQuery(document).ready(function() {
 $('[data-youtube]').youtube_background({
 'play-button': false,
 'autoplay': true,
 'load-background': true,
 'mute-button': false,
 'muted': true,
 'loop': true,
 'fit-box': true,
 'offset': true,
 'resolution': '16:9',
 'inline-styles': true

 });
 });*/
// jQuery(document).ready(function() {
//     jQuery('[data-youtube]').youtube_background({
//         'play-button': true
//     });
// });
// setTimeout(function() {
//     jQuery('#bgndVideo').YTPlayer({
//         onReady: function() {
//             console.log('player ready');
//         }
//     });
// }, 1000);
/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
//<editor-fold desc="IMAGES LOADED">
/*
 !function (e, t) {
 "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? module.exports = t() : e.EvEmitter = t()
 }("undefined" != typeof window ? window : this, function () {
 function e() {
 }

 var t = e.prototype;
 return t.on = function (e, t) {
 if (e && t) {
 var i = this._events = this._events || {},
 n = i[e] = i[e] || [];
 return n.indexOf(t) == -1 && n.push(t), this
 }
 }, t.once = function (e, t) {
 if (e && t) {
 this.on(e, t);
 var i = this._onceEvents = this._onceEvents || {},
 n = i[e] = i[e] || {};
 return n[t] = !0, this
 }
 }, t.off = function (e, t) {
 var i = this._events && this._events[e];
 if (i && i.length) {
 var n = i.indexOf(t);
 return n != -1 && i.splice(n, 1), this
 }
 }, t.emitEvent = function (e, t) {
 var i = this._events && this._events[e];
 if (i && i.length) {
 i = i.slice(0), t = t || [];
 for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
 var r = i[o],
 s = n && n[r];
 s && (this.off(e, r), delete n[r]), r.apply(this, t)
 }
 return this
 }
 }, t.allOff = function () {
 delete this._events, delete this._onceEvents
 }, e
 }), function (e, t) {
 "use strict";
 "function" == typeof define && define.amd ? define(["ev-emitter/ev-emitter"], function (i) {
 return t(e, i)
 }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter)
 }("undefined" != typeof window ? window : this, function (e, t) {
 function i(e, t) {
 for (var i in t) e[i] = t[i];
 return e
 }

 function n(e) {
 if (Array.isArray(e)) return e;
 var t = "object" == typeof e && "number" == typeof e.length;
 return t ? d.call(e) : [e]
 }

 function o(e, t, r) {
 if (!(this instanceof o)) return new o(e, t, r);
 var s = e;
 return "string" == typeof e && (s = document.querySelectorAll(e)), s ? (this.elements = n(s), this.options = i({}, this.options), "function" == typeof t ? r = t : i(this.options, t), r && this.on("always", r), this.getImages(), h && (this.jqDeferred = new h.Deferred), void setTimeout(this.check.bind(this))) : void a.error("Bad element for imagesLoaded " + (s || e))
 }

 function r(e) {
 this.img = e
 }

 function s(e, t) {
 this.url = e, this.element = t, this.img = new Image
 }

 var h = e.jQuery,
 a = e.console,
 d = Array.prototype.slice;
 o.prototype = Object.create(t.prototype), o.prototype.options = {}, o.prototype.getImages = function () {
 this.images = [], this.elements.forEach(this.addElementImages, this)
 }, o.prototype.addElementImages = function (e) {
 "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
 var t = e.nodeType;
 if (t && u[t]) {
 for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
 var o = i[n];
 this.addImage(o)
 }
 if ("string" == typeof this.options.background) {
 var r = e.querySelectorAll(this.options.background);
 for (n = 0; n < r.length; n++) {
 var s = r[n];
 this.addElementBackgroundImages(s)
 }
 }
 }
 };
 var u = {
 1: !0,
 9: !0,
 11: !0
 };
 return o.prototype.addElementBackgroundImages = function (e) {
 var t = getComputedStyle(e);
 if (t) for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n;) {
 var o = n && n[2];
 o && this.addBackground(o, e), n = i.exec(t.backgroundImage)
 }
 }, o.prototype.addImage = function (e) {
 var t = new r(e);
 this.images.push(t)
 }, o.prototype.addBackground = function (e, t) {
 var i = new s(e, t);
 this.images.push(i)
 }, o.prototype.check = function () {
 function e(e, i, n) {
 setTimeout(function () {
 t.progress(e, i, n)
 })
 }

 var t = this;
 return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function (t) {
 t.once("progress", e), t.check()
 }) : void this.complete()
 }, o.prototype.progress = function (e, t, i) {
 this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [this, e, t]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), this.options.debug && a && a.log("progress: " + i, e, t)
 }, o.prototype.complete = function () {
 var e = this.hasAnyBroken ? "fail" : "done";
 if (this.isComplete = !0, this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
 var t = this.hasAnyBroken ? "reject" : "resolve";
 this.jqDeferred[t](this)
 }
 }, r.prototype = Object.create(t.prototype), r.prototype.check = function () {
 var e = this.getIsImageComplete();
 return e ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image, this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), void (this.proxyImage.src = this.img.src))
 }, r.prototype.getIsImageComplete = function () {
 return this.img.complete && this.img.naturalWidth
 }, r.prototype.confirm = function (e, t) {
 this.isLoaded = e, this.emitEvent("progress", [this, this.img, t])
 }, r.prototype.handleEvent = function (e) {
 var t = "on" + e.type;
 this[t] && this[t](e)
 }, r.prototype.onload = function () {
 this.confirm(!0, "onload"), this.unbindEvents()
 }, r.prototype.onerror = function () {
 this.confirm(!1, "onerror"), this.unbindEvents()
 }, r.prototype.unbindEvents = function () {
 this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
 }, s.prototype = Object.create(r.prototype), s.prototype.check = function () {
 this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url;
 var e = this.getIsImageComplete();
 e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents())
 }, s.prototype.unbindEvents = function () {
 this.img.removeEventListener("load", this), this.img.removeEventListener("error", this)
 }, s.prototype.confirm = function (e, t) {
 this.isLoaded = e, this.emitEvent("progress", [this, this.element, t])
 }, o.makeJQueryPlugin = function (t) {
 t = t || e.jQuery, t && (h = t, h.fn.imagesLoaded = function (e, t) {
 var i = new o(this, e, t);
 return i.jqDeferred.promise(h(this))
 })
 }, o.makeJQueryPlugin(), o
 });


 //</editor-fold>*/
/**
 * imagefill.js
 * Author & copyright (c) 2013: John Polacek
 * johnpolacek.com
 * https://twitter.com/johnpolacek
 *
 * Dual MIT & GPL license
 *
 * Project Page: http://johnpolacek.github.io/imagefill.js
 *
 * The jQuery plugin for making images fill their containers (and be centered)
 *
 * EXAMPLE
 * Given this html:
 * <div class="container"><img src="myawesomeimage" /></div>
 * $('.container').imagefill(); // image stretches to fill container
 *
 * REQUIRES:
 * imagesLoaded - https://github.com/desandro/imagesloaded
 *
 */
/*;(function ($) {

 $.fn.imagefill = function (options) {

 var $container = this,
 imageAspect = 1 / 1,
 containersH = 0,
 containersW = 0,
 defaults = {
 runOnce: false,
 target: 'img',
 throttle: 200  // 5fps
 },
 settings = $.extend({}, defaults, options);

 var $img = $container.find(settings.target)
 .addClass('loading')
 .css({'position': 'absolute'});

 // make sure container isn't position:static
 var containerPos = $container.css('position');
 $container.css({
 'overflow': 'hidden',
 'position': (containerPos === 'static') ? 'relative' : containerPos
 });

 // set containerH, containerW
 $container.each(function () {
 containersH += $(this)
 .outerHeight();
 containersW += $(this)
 .outerWidth();
 });

 // wait for image to load, then fit it inside the container
 $container.imagesLoaded()
 .done(function (img) {
 imageAspect = $img.width() / $img.height();
 $img.removeClass('loading');
 fitImages();
 if (!settings.runOnce) {
 checkSizeChange();
 }
 });
 */

/*
 function checkSizeChange() {
 var checkW = 0,
 checkH = 0;
 $container.each(function () {
 checkH += $(this)
 .outerHeight();
 checkW += $(this)
 .outerWidth();
 });
 if (containersH !== checkH || containersW !== checkW) {
 fitImages();
 }
 setTimeout(checkSizeChange, settings.throttle);
 }

 return this;
 };

 }(jQuery));*/
// console.log(`${ 'Loaded' }`);